import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Field, Form } from 'react-final-form';
import { Container, Col, Row, Button } from 'reactstrap';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { actions } from '../../../context';
import { useHistory } from 'react-router-dom';
import FieldTitle from '../../Forms/FieldTitle';
import toast from 'react-hot-toast';

const AccountForm = ({ account = {}, refresh, closeForm, isNew = false }) => {
    const dispatch = useDispatch();
    let history = useHistory();
    const submit = async (values) => {
        const payload = { ...values };
        if (isNew === true) {
            dispatch(actions.accounts.createAccount(payload))
                .then((res) => {
                    if (res) {
                        history.push('/admin/accounts/' + res);
                        refresh();
                        closeForm();
                    }
                })
                .catch((err) => {
                    console.error(err);
                    toast(
                        () => (
                            <div className="text-light d-flex justify-content-between w-100">
                                Error: Creating the account failed, probably duplicate email or id wasn't a guid.
                                <br/>
                                <br/>
                                {JSON.stringify(err.response.data, null, 4)}
                            </div>
                        ),
                        {
                            duration: 7500,
                            style: {
                                minWidth: '25vw',
                                background: 'red',
                            },
                        }
                    );
                });
        } else {
            dispatch(actions.accounts.updateAccount(payload.id, payload))
                .then(() => {
                    refresh();
                    closeForm();
                })
                .catch((err) => {
                    console.error(err)
                    toast(
                        () => (
                            <div className="text-light d-flex justify-content-between w-100">
                                Error: Updating the account failed, probably duplicate email or id wasn't a guid.
                                <br/>
                                <br/>
                                {JSON.stringify(err.response.data, null, 4)}
                            </div>
                        ),
                        {
                            duration: 7500,
                            style: {
                                minWidth: '25vw',
                                background: 'red',
                            },
                        }
                    );
                });
        }
    };
    const [roles, setRoles] = useState([]);
    const getRoles = () =>
        dispatch(actions.roles.getRoles())
            .then((res) => setRoles(res?.data || []))
            .catch((err) => console.error(err));

    useEffect(() => {
        getRoles();
        // eslint-disable-next-line
    }, []);

    // TODO: put some better error behavior in
    return (
        <Form
            initialValues={account}
            onSubmit={submit}
            render={({ handleSubmit, form, submitting, pristine, values }) => (
                <form onSubmit={handleSubmit}>
                    <Container>
                        <Row>
                            <Col lg="6" md="6" sm="12" xs="12" className="mb-4">
                                <FieldTitle title="First Name" required />
                                <Field
                                    className="p-2 rounded w-100 border"
                                    component="input"
                                    name="firstName"
                                    placeholder="First"
                                    required
                                />
                            </Col>
                            <Col lg="6" md="6" sm="12" xs="12">
                                <FieldTitle title="Last Name" required />
                                <Field
                                    className="p-2 rounded w-100 border"
                                    component="input"
                                    name="lastName"
                                    placeholder="Last"
                                    required
                                />
                            </Col>
                            <Col lg="6" md="6" sm="12" xs="12" className="mb-4">
                                <FieldTitle title="Email Address" required />
                                <Field
                                    className="p-2 rounded w-100 border"
                                    component="input"
                                    name="email"
                                    placeholder="Email"
                                    required
                                />
                            </Col>
                            <Col lg="6" md="6" sm="12" xs="12">
                                <FieldTitle title="Role" required />
                                <Field
                                    className="p-2 rounded w-100"
                                    component="select"
                                    name="roleId"
                                    defaultValue={""}
                                    required>
                                    <option value="" disabled>
                                        Role
                                    </option>
                                    {roles.map((r, x) => (
                                        <option key={r.id} value={r.id}>
                                            {r.name.replace(
                                                /([a-z])([A-Z])/g,
                                                '$1 $2'
                                            )}
                                        </option>
                                    ))}
                                </Field>
                            </Col>
                            <Col xs="12" className="mb-4">
                                <FieldTitle title="Azure ID" required />
                                <Field
                                    className="p-2 rounded w-100 border"
                                    component="input"
                                    name="idpObjectId"
                                    placeholder="(ie. 3470ff3b-1d66-418a-a7ac-547ce662d277)"
                                    required
                                />
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col className="d-flex justify-content-between">
                                <div>
                                    <Button
                                        color="danger"
                                        disabled={pristine}
                                        onClick={() => form.reset()}>
                                        <FontAwesomeIcon icon={faTrashAlt} />
                                        &emsp;Clear
                                    </Button>
                                </div>
                                <div className="text-right">
                                    <Button
                                        className="mx-2"
                                        color="danger"
                                        onClick={closeForm}>
                                        Cancel
                                    </Button>
                                    <Button
                                        className="mx-2"
                                        type="submit"
                                        color="success"
                                        disabled={pristine || submitting}>
                                        Submit
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </form>
            )}
        />
    );
};

export default AccountForm;
